import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute p-1 top-0 right-1 text-gray-700 cursor-pointer shadow-2xl bg-inherit rounded-full"
}
const _hoisted_2 = {
  key: 0,
  class: "absolute top-5 right-1 z-30 text-gray-700 cursor-pointer"
}
const _hoisted_3 = {
  class: "mt-2 bg-white shadow-xl rounded",
  id: "dropdown"
}
const _hoisted_4 = { class: "flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.focus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Icon, {
            name: "ChevronDown",
            size: "12",
            color: _ctx.color,
            onClick: _cache[0] || (_cache[0] = () => _ctx.toogle = true)
          }, null, 8, ["color"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      "leave-active-class": "transition duration-100 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0",
      "enter-active-class": "transition duration-100 ease-in",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100"
    }, {
      default: _withCtx(() => [
        (_ctx.toogle && _ctx.focus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                    class: "block px-4 py-2 w-32 text-sm text-left capitalize webchat-transition text-neutral-500 hover:text-neutral-700"
                  }, " Responder ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}